import { i18next, initReactI18next, LanguageDetector } from '@coinflare/ui/translations';

import { DEFAULT_LANGUAGE } from 'src/config';

import de from '../assets/locales/de/translation';
import en from '../assets/locales/en-us/translation';
import es from '../assets/locales/es/translation';
import it from '../assets/locales/it/translation';
import ko_kr from '../assets/locales/ko-kr/translation';
import lt from '../assets/locales/lt/translation';
import pt from '../assets/locales/pt/translation';
import ru from '../assets/locales/ru/translation';
import tr from '../assets/locales/tr/translation';
import vi from '../assets/locales/vi/translation';

export const rtlLanguages = ['ar', 'he'];
export const supportedLanguages = [
    'en-us',
    'de',
    'tr',
    'ru',
    'es',
    'ko-kr',
    'vi',
    'it',
    'pt',
    'lt',
];

const resources = {
    'en-us': {
        translation: en,
    },
    de: {
        translation: de,
    },
    tr: {
        translation: tr,
    },
    ru: {
        translation: ru,
    },
    es: {
        translation: es,
    },
    'ko-kr': {
        translation: ko_kr,
    },
    vi: {
        translation: vi,
    },
    it: {
        translation: it,
    },
    pt: {
        translation: pt,
    },
    lt: {
        translation: lt,
    },
};

i18next
    .use(initReactI18next)
    .use(LanguageDetector)
    .init({
        load: 'currentOnly',
        supportedLngs: supportedLanguages,
        fallbackLng: DEFAULT_LANGUAGE,
        lowerCaseLng: true,
        resources,
        detection: {
            order: ['localStorage'],
            lookupLocalStorage: 'activeLanguage',
            caches: ['localStorage'],
        },
        react: {
            bindI18n: 'languageChanged',
            transSupportBasicHtmlNodes: true,
            transKeepBasicHtmlNodesFor: ['br', 'strong', 'b', 'p', 'h1', 'h2', 'u', 'a', 'li'],
        },
    });

export default i18next;

export const changeLanguage = i18next.changeLanguage;
